import { render, staticRenderFns } from "./DEST.vue?vue&type=template&id=2325f71e&scoped=true&"
import script from "./DEST.vue?vue&type=script&lang=js&"
export * from "./DEST.vue?vue&type=script&lang=js&"
import style0 from "./DEST.vue?vue&type=style&index=0&id=2325f71e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2325f71e",
  null
  
)

export default component.exports